// removed by extract-text-webpack-plugin
module.exports = {"root":"root___I9OEL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/IncomeDetailModal/Index.less
// module id = WMf2
// module chunks = 14 15 20 28